import { baseurl } from "../../api";
import authenticatedAxios from "../../authenticatedAxios";


export const getActiveFaqCategories = async () => {
  const response = await authenticatedAxios.get(`${baseurl}faq/category/active/`);
  return response.data;
};

export const getFaqCategoryById = async (id) => {
  try {
    const response = await authenticatedAxios.get(`${baseurl}faq/category/?id=${id}`);
    if (response.data.response_code === 1) {
      return response.data.data;
    }
    throw new Error("No data found for the selected category.");
  } catch (error) {
    throw new Error(error.message || "Failed to fetch category by id");
  }
};

export const getFaqCategories = async (params) => {
  try {
    const response = await authenticatedAxios.get(`${baseurl}faq/category/`, { params });
    if (response.data.response_code === 1) {
      return response.data.data;
    }
    throw new Error("Failed to fetch FAQ categories.");
  } catch (error) {
    throw new Error(error.message || "Failed to fetch FAQ categories.");
  }
};


export const addFaqCategory = async (formValues) => {
  try {
    const response = await authenticatedAxios.post(`${baseurl}faq/category/`, formValues);

    if (response.data.response_code === 1) {
      return response.data; 
    } else {
      throw new Error(response.data.message || 'Something went wrong!');
    }
  } catch (error) {
    throw new Error(error.message || 'Failed to add category');
  }
};


export const editFaqCategory = async (id, formValues) => {
  try {
    const response = await authenticatedAxios.put(
      `${baseurl}faq/category/?id=${id}`,
      formValues
    );

    if (response.data.response_code === 1) {
      return response.data;
    } else {
      throw new Error(response.data.message || 'Something went wrong!');
    }
  } catch (error) {
    throw new Error(error.message || 'Failed to update category');
  }
};

export const archiveCategory = async (id) => {
  try {
    const response = await authenticatedAxios.get(`${baseurl}faq/category/archive/?id=${id}`);
    if (response.status >= 200 && response.status < 300) {
      return response.data;
    } else {
      throw new Error("Failed to archive category");
    }
  } catch (error) {
    throw new Error(error.message || "Archiving failed");
  }
};

// Archive multiple categories
export const archiveCategoriesBulk = async (idList) => {
  try {
    const response = await authenticatedAxios.post(`${baseurl}faq/category/archive/`, {
      id_list: idList,
    });

    if (response.status >= 200 && response.status < 300) {
      return response.data;
    } else {
      throw new Error("Failed to archive selected categories");
    }
  } catch (error) {
    throw new Error(error.message || "Bulk archive failed");
  }
};

// Delete category
export const deleteCategory = async (id) => {
  try {
    const response = await authenticatedAxios.delete(`${baseurl}faq/category/?id=${id}`);
    if (response.status >= 200 && response.status < 300) {
      return response.data;
    } else {
      throw new Error("Failed to delete category");
    }
  } catch (error) {
    throw new Error(error.message || "Delete failed");
  }
};